export {};
//# sourceMappingURL=IAppInsightsCore.js.map